// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueWorker from 'vue-worker'
import IdleVue from 'idle-vue'

import App from './App'
import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

const eventsHub = new Vue()

Vue.use(VueI18n)
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(VueWorker, '$etaWk')
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 3600000,
  startAtIdle: false,
  store: store,
  moduleName: "eta-idle",
})

let messages = {}

const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'fr': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const numberFormats = {
  'en': {
    currency: {
      style: 'currency',
      currency: 'USD'
    },
    percent: {
      style: 'percent'
    }
  },
  'fr': {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percent: {
      style: 'percent'
    }
  }
}

let i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
  dateTimeFormats, // set date and time formats
  numberFormats // set number formats
})

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})
